module.exports = __webpack_public_path__ + "img/autoc-close.6ea64dc7.svg";